import axios from "axios";

export const getActiveProductionOrders = async (companyKey) => {
    const response = await axios.get(`api/activeProductionOrder?companyKey=${companyKey}`);
    const data = response.data;
    return data;
}

export const updateActiveProductionOrder = async (productionOrder) => {
    const response = await axios.patch(`api/activeProductionOrder`, productionOrder);
    const data = response.data;
    return data;
}

export const createActiveProductionOrder = async (productionOrder) => {
    const response = await axios.post(`api/activeProductionOrder`, productionOrder);
    const data = response.data;
    return data;
}

export const deleteActiveProductionOrder = async (machineId) => {
    const response = await axios.delete(`api/activeProductionOrder/${machineId}`);
    const data = response.data;
    return data;
}
